module.exports = __webpack_public_path__ + "img/visitor_graph.345e9b5e.png";